import OpenWithIcon from '@mui/icons-material/OpenWith';
import PaletteIcon from '@mui/icons-material/Palette';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import { ActionButton } from '../types';
import { getStopeFillSceneState, updateStopeFillSceneState } from './stopeFillSceneState';

const getStopeFilSceneActions = (): ActionButton[] => {
  const togglePipeMoveAction: ActionButton = {
    value: 'TogglePipeMove',
    ariaLabel: 'Toggle Position Move',
    tooltip: () => (getStopeFillSceneState().enablePositionMove ? 'Move Position: On' : 'Move Position: Off'),
    icon: () => (
      <OpenWithIcon color={getStopeFillSceneState().enablePositionMove ? 'secondary' : 'disabled'} />
    ),
    selected: () => getStopeFillSceneState().enablePositionMove,
    onClick: () => {
      const currentState = getStopeFillSceneState();
      updateStopeFillSceneState({ enablePositionMove: !currentState.enablePositionMove });
    },
  };

  // Single button that alternates between by-pour and by-recipe colour modes.
  // Icon + tooltip update based on the current mode; clicking toggles.
  const togglePourColourAction: ActionButton = {
    value: 'TogglePourColour',
    ariaLabel: 'Toggle Pour Colour Mode',
    tooltip: () => (getStopeFillSceneState().pourColorDisplay === 'by-recipe'
      ? 'Colour: By Recipe (click for By Pour)'
      : 'Colour: By Pour (click for By Recipe)'),
    icon: () => (getStopeFillSceneState().pourColorDisplay === 'by-recipe'
      ? <GroupWorkIcon color="secondary" />
      : <PaletteIcon color="secondary" />),
    selected: () => getStopeFillSceneState().pourColorDisplay === 'by-recipe',
    onClick: () => {
      const currentState = getStopeFillSceneState();
      updateStopeFillSceneState({
        pourColorDisplay: currentState.pourColorDisplay === 'by-recipe' ? 'by-pour' : 'by-recipe',
      });
    },
  };

  return [
    togglePipeMoveAction,
    togglePourColourAction,
  ];
};

export default getStopeFilSceneActions;
